class KinkyMarquee extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-marquee-viewport]');
    this.track = this.querySelector('[data-marquee-track]');
    this.templateGroup = this.querySelector('[data-marquee-template]');
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!this.viewport || !this.track || !this.templateGroup) return;

    this.handleMotionChange = () => this.scheduleSetup();
    this.handleResize = () => this.scheduleSetup();

    if ('addEventListener' in this.motionQuery) {
      this.motionQuery.addEventListener('change', this.handleMotionChange);
    }

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.scheduleSetup());
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.templateGroup);
    } else {
      window.addEventListener('resize', this.handleResize);
    }

    this.scheduleSetup();
  }

  disconnectedCallback() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    } else {
      window.removeEventListener('resize', this.handleResize);
    }

    if (this.motionQuery && 'removeEventListener' in this.motionQuery) {
      this.motionQuery.removeEventListener('change', this.handleMotionChange);
    }
  }

  scheduleSetup() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }

    this.animationFrame = requestAnimationFrame(() => {
      this.animationFrame = null;
      this.setup();
    });
  }

  setup() {
    if (!this.viewport || !this.track || !this.templateGroup) return;

    this.track.querySelectorAll('[data-marquee-clone="true"]').forEach((node) => node.remove());

    const sourceWidth = this.templateGroup.scrollWidth;
    const gap = parseFloat(getComputedStyle(this.track).gap || '0');
    const reducedMotion = this.motionQuery.matches;

    if (!sourceWidth) {
      this.dataset.ready = 'false';
      return;
    }

    const unitWidth = sourceWidth + gap;
    const visibleWidth = this.viewport.clientWidth;
    const minimumCopies = reducedMotion ? 1 : Math.max(2, Math.ceil(visibleWidth / unitWidth) + 2);

    for (let index = 1; index < minimumCopies; index += 1) {
      const clone = this.templateGroup.cloneNode(true);
      clone.dataset.marqueeClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      this.stripEditorAttributes(clone);
      this.track.appendChild(clone);
    }

    const pixelsPerSecond = Math.max(24, Number(this.dataset.speed) || 80);
    const duration = Math.max(12, unitWidth / pixelsPerSecond);

    this.style.setProperty('--marquee-shift', `${unitWidth}px`);
    this.style.setProperty('--marquee-duration', `${duration}s`);
    this.dataset.ready = reducedMotion ? 'false' : 'true';
  }

  stripEditorAttributes(root) {
    [root, ...root.querySelectorAll('*')].forEach((element) => {
      Array.from(element.attributes).forEach((attribute) => {
        if (attribute.name.startsWith('data-shopify')) {
          element.removeAttribute(attribute.name);
        }

        if (attribute.name === 'id' && attribute.value.startsWith('shopify-block-')) {
          element.removeAttribute(attribute.name);
        }
      });
    });
  }
}

if (!customElements.get('kinky-marquee')) {
  customElements.define('kinky-marquee', KinkyMarquee);
}
